/** @format */

import $ from "jquery";
import axios from "axios";
import { Empty } from "antd";
import { useReactToPrint } from "react-to-print";
import React, { useEffect, useState, useRef } from "react";

import { CloseOutlined } from "@ant-design/icons";

import Card from "../../../../components/Card";
import print from "../../../../icons/print.png";
import excel from "../../../../icons/excel.png";
import Minimap from "../../../../components/map/Minimap";
import Chart1 from "../../../../components/Charts/Chart1";
import { header } from "../../../../components/api/Header";
import { ExcelPrint } from "../../../../components/functions/Print";
import { monthDays, monthName } from "../../../../components/functions/Month";
import LoadingCard from "../../../../components/loading/loadingCard";
import { getEnv } from "../../../../lib/env";
import { formatTableValue } from "./formatTableValue";

function Kunlik({ region, regionId, vaqt, itbId, periodTabs }) {
  const conponentPDF = useRef();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState("");
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));

  const [lmonth, setLmonth] = useState(month);

  useEffect(() => {
    let active = true;
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${getEnv('REACT_APP_BASE_URL')}/v1/republik/asosiymanbalar/kunlik?regionId=${regionId}&month=${month}&vaqt=${vaqt}`,
          { ...header(), params: { itbId } }
        );
        if (active) setData(res.data);
      } catch (e) {
        if (!active) return;
        setData([]);
        console.log("Xato", e);
        alert("Serverga ulanishda xato!");
      } finally {
        if (active) setLoading(false);
      }
    };
    fetchData();
    return () => { active = false; };
  }, [month, regionId, vaqt, itbId]);

  useEffect(() => {
    setMonth(lmonth);
  }, [lmonth]);

  useEffect(() => {
    close();
  }, [regionId, itbId]);

  const chiz = (index) => {
    removeChecked();
    let v = $("tr.tr" + index + " input");
    let checked = v[0].checked;
    v[0].checked = !checked;
    if (!checked) {
      $("tr.tr" + index).addClass("active");
    } else {
      $("tr.tr" + index).removeClass("active");
    }
    setSelectedRowKeys(index);
  };

  const removeChecked = () => {
    if (selectedRowKeys !== "") {
      const checkbox = $("tr.tr" + selectedRowKeys + " input")[0];
      if (checkbox) checkbox.checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
  };

  const close = () => {
    if (selectedRowKeys !== "") {
      const checkbox = $("tr.tr" + selectedRowKeys + " input")[0];
      if (checkbox) checkbox.checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
    setSelectedRowKeys("");
  };

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Userdata",
    onAfterPrint: () => alert("Data saved in PDF"),
  });

  return (
    <>
      <div className='table-box'>
        <div className='table-content-top'>
          <div className='table-top-left'>
            {periodTabs}
          </div>

          <ul className='table-top-right'>
            <li>
              <div className='d-flex'>
                <input
                  type='month'
                  className='form-control form-control-sm'
                  value={lmonth}
                  onChange={(e) => setLmonth(e.target.value)}
                />
              </div>
            </li>

            <li>
              <button className='btn p-0' onClick={() => generatePDF()}>
                <img src={print} alt='404' />
              </button>
            </li>

            <li>
              <button
                className='btn p-0'
                onClick={() =>
                  ExcelPrint("Asosiy manbalar " + region, month, "tblData")
                }>
                <img src={excel} alt='404' />
              </button>
            </li>
          </ul>
        </div>

        {loading ? (
          <LoadingCard loading={loading} heightSize='80vh' />
        ) : (
          <div id='content'>
            <div
              id='tableFlexible'
              style={{ height: selectedRowKeys === "" ? "79vh" : "37vh" }}>
              <div ref={conponentPDF} style={{ width: "100%" }}>
                {data.length > 0 ? (
                  <table
                    id='tblData'
                    className='table table-bordered table-style fixedHeader'>
                    <thead>
                      <tr>
                        <th rowSpan={3} className='sticky st1'>
                          o
                        </th>

                        <th
                          rowSpan={3}
                          className='sticky'
                          style={{ left: "31px" }}>
                          T/R
                        </th>

                        <th
                          rowSpan={3}
                          className='sticky'
                          style={{ left: "71px" }}>
                          Irrigatsiya tizimlari nomi va asosiy suvolish
                          nuqtalari
                        </th>

                        <th
                          rowSpan={3}
                          className='sticky'
                          style={{ left: "368px" }}>
                          O’lchov birligi
                        </th>

                        <th colSpan={monthDays(month) * 2}>
                          {monthName(month)}
                        </th>
                      </tr>

                      <tr>
                        {Array.from({ length: monthDays(month) }, (_, i) => (
                          <th key={i} colSpan={2}>
                            {(i + 1).toString().padStart(2, "0")}
                          </th>
                        ))}
                      </tr>

                      <tr>
                        {Array.from({ length: monthDays(month) }, (_, i) => (
                          <React.Fragment key={i}>
                            <th key={`e-${i}`}>ert</th>
                            <th key={`o-${i}`}>o'rt</th>
                          </React.Fragment>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {data.map((d, index) => (
                        <tr key={index} className={`tr tr${index}`}>
                          <td className='sticky st1'>
                            <input type='checkbox' />
                          </td>

                          <td className='sticky' style={{ left: "31px" }}>
                            {index + 1}
                          </td>

                          <td
                            onClick={() => chiz(index)}
                            className={`text-start sticky fix-with ${
                              d.lat !== "" && d.lan !== "" ? "haslocation" : ""
                            }`}
                            style={{ left: "71px" }}>
                            {d.manba_nomi}
                          </td>

                          <td
                            onClick={() => chiz(index)}
                            className='text-start sticky'
                            style={{ left: "368px" }}>
                            {d.birligi}
                          </td>

                          {Array.from({ length: monthDays(month) }, (_, i) => (
                            <React.Fragment key={i}>
                              <td
                                onClick={() => chiz(index)}
                                style={{
                                  maxWidth: "70px",
                                  minWidth: "65px",
                                  textAlign: "center",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}>
                                {formatTableValue(d[`e${i + 1}`])}
                              </td>

                              <td
                                onClick={() => chiz(index)}
                                style={{
                                  maxWidth: "70px",
                                  minWidth: "65px",
                                  textAlign: "center",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}>
                                {formatTableValue(d[`k${i + 1}`])}
                              </td>
                            </React.Fragment>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <Empty description="Ma'lumot mavjud emas" />
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {selectedRowKeys.length === 0 ? null : (
        <div
          className='data-content mt-3 mainpage'
          style={{ position: "relative" }}>
          <CloseOutlined
            style={{
              position: "absolute",
              top: 0,
              right: 10,
              zIndex: 9,
              fontSize: "20px",
              cursor: "pointer",
            }}
            onClick={close}
          />

          <Card>
            {(() => {
              const selected = data[selectedRowKeys];
              const { lat, lan } = selected || {};

              if (lat != null && lan != null) {
                return (
                  <Minimap location={[lat, lan]} locations={[]} zoom={13} />
                );
              }

              return null;
            })()}
          </Card>

          <Chart1 datas={data[selectedRowKeys]} month={month} />
        </div>
      )}
    </>
  );
}

export default Kunlik;
